import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgCamera = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height={60}
        width={60}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 60 60"
    >
        <g filter="url(#filter0_d_19028_22892)">
            <path
                clipRule="evenodd"
                d="M30 40C37.732 40 44 33.732 44 26C44 18.268 37.732 12 30 12C22.268 12 16 18.268 16 26C16 33.732 22.268 40 30 40Z"
                fill="#715AFF"
                fillRule="evenodd"
            />
        </g>
        <path
            d="M29.9968 24.6223C28.8924 24.6421 28.0123 25.5535 28.031 26.6579C28.0497 27.7623 28.9602 28.6415 30.0646 28.6217C31.169 28.6019 32.0491 27.6906 32.0304 26.5861C32.0214 26.0558 31.8021 25.5509 31.4207 25.1826C31.0393 24.8143 30.5271 24.6128 29.9968 24.6223Z"
            fill="white"
        />
        <path
            d="M31.792 20C32.6846 19.9966 33.4815 20.5611 33.7793 21.4072L34.0039 22.1113H34.8994C35.4625 22.1113 36.0026 22.3386 36.3975 22.7422C36.7922 23.1457 37.0093 23.6919 37 24.2578V29.8887C36.9999 31.0548 36.0592 32 34.8994 32H25.0996C23.94 31.9998 23.0001 31.0546 23 29.8887V24.2578C23.0001 23.092 23.9401 22.1467 25.0996 22.1465H25.9961L26.2197 21.4424C26.5055 20.5822 27.306 20.0017 28.208 20H31.792ZM30 23.8008C28.4873 23.8008 27.2607 25.0771 27.2607 26.6514C27.2609 28.2255 28.4874 29.501 30 29.501C31.5126 29.5009 32.7391 28.2254 32.7393 26.6514C32.7393 25.0772 31.5127 23.8009 30 23.8008Z"
            fill="white"
        />
        <defs>
            <filter
                colorInterpolationFilters="sRGB"
                filterUnits="userSpaceOnUse"
                height="60"
                id="filter0_d_19028_22892"
                width="60"
                x="0"
                y="0"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="8" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.22793 0 0 0 0 0.296539 0 0 0 0 0.3872 0 0 0 0.0562445 0"
                />
                <feBlend
                    in2="BackgroundImageFix"
                    mode="normal"
                    result="effect1_dropShadow_19028_22892"
                />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_19028_22892"
                    mode="normal"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
);

export const CameraIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgCamera}
        fontSize={fontSize}
    />
);
